"use client";

import { getImageSource } from "../../../helpers/getImageSource";
import { responsiveImageHelper } from "../../../helpers/responsiveImageHelper";
import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import styles from "./RandomHomePageImage.module.css";

const cx = classNames.bind(styles);

interface RandomImageProps {
  imageUrls: string[];
  className?: string;
}

export function RandomHomePageImage({
  imageUrls,
  className,
}: RandomImageProps) {
  const [randomImage, setRandomImage] = useState<string | null>(null);

  useEffect(() => {
    if (imageUrls.length > 0) {
      const selectedImage =
        imageUrls[Math.floor(Math.random() * imageUrls.length)];
      setRandomImage(selectedImage);
    }
  }, [imageUrls]);

  if (!randomImage) {
    return null;
  }

  const imageUrl = randomImage;
  const imageSource = getImageSource(imageUrl);

  return (
    <>
      {(() => {
        const imageProps = {
          className: cx("image", className),
          alt: "",
        };

        switch (imageSource) {
          case "storyblok": {
            return (
              <img
                {...imageProps}
                srcSet={responsiveImageHelper.createStoryblokSrcSet(imageUrl)}
                sizes="(min-width: 1472px) 1472px, 100vw"
              />
            );
          }
          default: {
            return <img {...imageProps} src={imageUrl} />;
          }
        }
      })()}
    </>
  );
}
